import gql from 'graphql-tag';

const GET_ORGANISATION_QUERY = gql`
  query GetOrganisation($organisationId: String!)
  {
    getOrganisation(organisationId: $organisationId) {
      name
      shutterstockAccess
      creditBalance {
        balance
        creditTotal
        rolloverBalance
        rolloverTotal
      }
    }
  }`;

export default ((organisationId) => ({
  query: GET_ORGANISATION_QUERY,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: () => ({
    organisationId
  }),
  isSilent: true
}));